<button mat-icon-button
        disableRipple="true"
        (click)="onClick()"
        [disabled]="disabled">
  <mat-icon>{{ getIcon() }}</mat-icon>
</button>
